// <-- 기타 -->
export const LOGIN_API = '/management/machine/get/management_machine' // 로그인

// <-- 프로토 -->
export const LIST_OF_GAME_DATA_API = '/game/info/list/get/game_info_list' // 게임 데이터 가져오기

export const SEND_PRINT_INFO_API = '/game/print/list/set/game_print_list' // 출력할때 정보 넘겨주기

// <-- 바구니 -->
export const GET_BASKET_TICKET_DATA_LIST_API = '/basket/game/info/list/get/basket_game_info_list' // 바구니 티켓 리스트 검색

// <-- 토토 -->
export const GET_TOTO_GAME_INFO_API = '/game/toto/list/get/game_toto_list' // 토토 경기정보 가져오기
export const SEND_TOTO_WDL_PRINT_INFO_API = '/game/wdl/print/list/set/wdl_print_list' // 토토 승무패 출력할때 정보 넘겨주기

// <-- 경기분석 -->
export const GET_GAME_ANALYSIS_URL_API = '/analysis/score/comparison/get/analysis_score_comparison' // 경기분석
export const GET_SAME_RATE_INFO_LIST_API = '/game/info/list/get/filter/rate/game_info_list' // 동일 배당 경기 정보 불러오기


